export default __webpack_public_path__ + "static/media/MILLERLogo-copia.c66c9c84.jpg";